import { useNavigate } from 'react-router-dom';
import DrinkWindowBadge from './DrinkWindowBadge';
import type { CellarItem } from '@/hooks/useCellar';

interface CellarListProps {
  items: CellarItem[];
}

export default function CellarList({ items }: CellarListProps) {
  const navigate = useNavigate();

  if (items.length === 0) {
    return <p className="cellar-empty">No wines here yet.</p>;
  }

  return (
    <ul className="cellar-list">
      {items.map((item) => (
        <li
          key={item.wineId}
          className="cellar-list-item"
          onClick={() => navigate(`/wine/${item.wineId}`)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && navigate(`/wine/${item.wineId}`)}
        >
          <div className="cellar-list-info">
            <p className="cellar-list-name">{item.wine.name}</p>
            <p className="cellar-list-meta">
              {[item.wine.producer, item.wine.vintage, item.wine.region]
                .filter(Boolean)
                .join(' · ')}
            </p>
            <DrinkWindowBadge drinkFrom={item.drinkFrom} drinkBy={item.drinkBy} />
          </div>
          <div className="cellar-list-right">
            <span className="cellar-list-qty">×{item.quantity}</span>
          </div>
        </li>
      ))}
    </ul>
  );
}
